import { Dispatch, SetStateAction, useContext } from 'react';
import { useRouter } from 'next/router';
import { ICON_BY_NAME } from 'ui/components/Icons/Icon';
import { QueryParamDrawer, Routes, PageTitle, User } from '../../types';
import { AuthContext } from '../../providers';
import { NavigationLink } from 'ui/types';
import { Feature, useFeatures } from 'hooks/useFeatures';
import Gleap from 'gleap';
interface profileDropdownLinksProps {
  pathname: string;
  userData: User;
  setTitle: Dispatch<SetStateAction<string>>;
  isTeams?: boolean;
}
export const profileDropdownLinks = ({
  pathname,
  userData,
  setTitle,
  isTeams
}: profileDropdownLinksProps) => {
  const router = useRouter();
  const {
    logout
  } = useContext(AuthContext);
  const profileImage = userData?.imageUrl;
  const hasStripePayouts = useFeatures(Feature.StripePayouts);
  let subLinks: NavigationLink[] = [{
    label: 'My Profile',
    href: Routes.Profile,
    isActive: pathname === Routes.Profile,
    icon: <ICON_BY_NAME.profile width="15px" height="15px" />
  }, {
    label: 'Settings',
    isActive: false,
    icon: <ICON_BY_NAME.settingscogoutline width="15px" height="15px" />,
    renderAsButton: true,
    onClick: async (): Promise<void> => {
      await router.replace({
        pathname: router.pathname,
        query: {
          ...router.query,
          drawer: QueryParamDrawer.ManageSettings
        }
      });
    }
  }, ...(hasStripePayouts ? [{
    label: 'Payout Methods',
    isActive: false,
    icon: <ICON_BY_NAME.moneybagdiamond width="15px" height="15px" />,
    renderAsButton: true,
    onClick: async () => {
      await router.replace({
        pathname: router.pathname,
        query: {
          ...router.query,
          drawer: QueryParamDrawer.PayoutSettings
        }
      });
    }
  }] : []), {
    label: 'Documentation',
    isActive: false,
    icon: <ICON_BY_NAME.files width="15px" height="15px" />,
    onClick: () => {
      window.open('https://arcadesite.webflow.io/docs', '_blank');
    }
  }, {
    label: 'Get Support',
    isActive: false,
    icon: <ICON_BY_NAME.helpcircle width="15px" height="15px" />,
    onClick: () => {
      Gleap.open();
    }
  }, {
    label: 'Log out',
    isActive: false,
    icon: <ICON_BY_NAME.logoutwide width="15px" height="15px" />,
    onClick: () => {
      logout();
      setTitle(PageTitle.Arcade);
    }
  }];
  return {
    label: 'My Account',
    hasProfileImage: !isTeams,
    icon: <ICON_BY_NAME.account width="15px" height="15px" />,
    imageUrl: profileImage,
    name: userData?.fullName,
    isActive: pathname === Routes.Profile,
    subLinks: subLinks
  };
};